var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal",class:{ active: _vm.show }},[(_vm.show)?_c('div',[_c('div',[_c('SurveyAdvancedSettings')],1),_c('div',{staticClass:"button"},[_c('button',{on:{"click":function($event){$event.preventDefault();return _vm.closeModal()}}},[_vm._v("\n        "+_vm._s(_vm.parseTranslation(_vm.CLOSE))+"\n      ")])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }